import { BsNewspaper } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import ImageNotFound from '../../../images/homepage/Image_not_available.png';
interface Props {
    categoryHorizontalNews: any;
    numberNews: number;
}

const HorizontalCategory = (props: Props) => {

    const navigate = useNavigate();

    // Hàm thực hiện thay thế ảnh khi ảnh bị lỗi
    const handleImageError = (e: any) => {
        e.target.onerror = null;
        e.target.src = ImageNotFound;
    }
    return (
        <div className='horizontal-category'
            onClick={() => {
                const url = new URL(props.categoryHorizontalNews.link);
                const text = url.hostname + url.pathname;
                const id = props.categoryHorizontalNews.id
                console.log(text);
                // const tmp = props.newsContent.title.replace(/[/,:?-]/g, '');
                // const title = tmp.replace(/ /g, '-').toLowerCase();

                if (props.categoryHorizontalNews.type === 'AI'|| text.includes('watch')) {
                    navigate(`/detail-news/id=${id}`,);
                }
                else {
                    navigate(`/detail-news/${text}`);
                }

                // Gán giá trị id vào localStorage
                localStorage.setItem('id', props.categoryHorizontalNews.id);
                localStorage.setItem('link', props.categoryHorizontalNews.link);
            }}>
            <div className='image-horizontal-category'>
                <img
                    src={props.categoryHorizontalNews.imageContents[0] ? props.categoryHorizontalNews.imageContents[0] : ImageNotFound}
                    alt=''
                    onError={handleImageError}

                />
                <div className='view-more-news'>
                    <BsNewspaper /> {props.numberNews} tin liên quan
                </div>
            </div>
            <div className='title-horizontal-category'>
                {props.categoryHorizontalNews.title}
            </div>
            <div className="number-horizontal-category">
                Bài viết được tổng hợp từ {props.numberNews} nguồn tin
            </div>


        </div>
    )
}

export default HorizontalCategory
